import { createContext, useContext, useState, useMemo } from 'react';

const ShopLangContext = createContext({ lang: 'en', setLang: () => {} });

export const ShopLangProvider = ({ children }) => {
  const [lang, setLang] = useState('en');
  const value = useMemo(() => ({ lang, setLang }), [lang]);
  return (
    <ShopLangContext.Provider value={value}>{children}</ShopLangContext.Provider>
  );
};

export const useShopLang = () => useContext(ShopLangContext);

export default ShopLangContext;
